import * as React from "react";
import { Container } from "@mui/material";
import { ProductRepositoryProvider } from "../context/ProductRepositoryState";
import SummaryTableController from "../component/SummaryTableController";
import SearchController from "../component/SearchController";
import SummaryButtons from "../component/SummaryButtons";

const SummaryTablePage = () => {
  return (
    <Container>
      <ProductRepositoryProvider>
        <SummaryButtons />
        <SearchController />
        <SummaryTableController />
      </ProductRepositoryProvider>
    </Container>
  );
};

export default SummaryTablePage;
